export default {
  apiKey: '2564333f-3201-4cee-adaf-d3beaf650208',
  chartOptions: {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            min: 0,
            fontColor: '#fff',
          },
          gridLines: {
            drawBorder: false,
            color: 'rgba(255,255,255,0.1)',
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontColor: '#fff',
          },
          gridLines: {
            drawBorder: false,
            color: 'rgba(255,255,255,0.1)',
          },
        },
      ],
    },
    legend: {
      labels: {
        fontColor: '#fff',
      },
    },
  },
  chartOptionsConsumptionProduction: {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            min: 0,
            fontColor: '#fff',
          },
          gridLines: {
            drawBorder: false,
            color: 'rgba(255,255,255,0.2)',
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontColor: '#fff',
          },
          gridLines: {
            drawBorder: false,
            color: 'rgba(255,255,255,0.1)',
          },
        },
      ],
    },
    legend: {
      labels: {
        fontColor: '#fff',
      },
    },
  },

  chartOptionsProfitability: {
    responsive: true,
    maintainAspectRatio: false,
    height: '500px',
    scales: {
      yAxes: [
        {
          ticks: {
            fontColor: '#fff',
          },
          gridLines: {
            drawBorder: false,
            color: 'rgba(255,255,255,0.1)',
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontColor: '#fff',
          },
          gridLines: {
            drawBorder: false,
            color: 'rgba(255,255,255,0.1)',
          },
        },
      ],
    },
    legend: {
      labels: {
        fontColor: '#fff',
      },
    },
  },
};
